import { Modifier } from "@/dto/modifer";
import { SpecialInstructions } from "./specialInstructions";

export interface CartItemModifierListProps {
  modifiers: Modifier[];
  specialInstructions?: string;
}

export const CartItemModifierList = ({
  modifiers,
  specialInstructions,
}: CartItemModifierListProps) => {
  return (
    <div className="max-w-[80%]">
      {modifiers.length > 0 && (
        <p className="text-[15px] text-[#727272]">
          {modifiers.map((modifier: any) => modifier.name).join(", ")}
        </p>
      )}
      <SpecialInstructions specialInstructions={specialInstructions} />
    </div>
  );
};
